import React, { useState } from "react";
import Grid from "@mui/material/Grid2";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import useMediaQuery from "@mui/material/useMediaQuery";

const ConditionalQuestionGroup = ({ question, isVisible, renderField, setFieldValue }) => {
  const [enabled, setEnabled] = useState(false);
  const visibleFields = question.fields.filter(subq => isVisible(subq));
  const isMobile = useMediaQuery('(max-width:600px)');
  
  const handleToggle = (e) => {
    const checked = e.target.checked;
    setEnabled(checked);
    if (checked && setFieldValue) {
      visibleFields.forEach(field => {
        if (field.default !== undefined) {
          setFieldValue(field.id, field.default);
        }
      });
    } else if (!checked && setFieldValue && question.fixed_field?.default !== undefined) {
      setFieldValue(question.fixed_field.id, question.fixed_field.default);
    }
  };

  return (
    <Grid container spacing={2} direction="column">
      <Grid item>
        {enabled ? (
          // New two-column layout for visible fields with mobile responsiveness
          <Grid container spacing={2} direction="row" alignItems="center" justifyContent="flex-start">
            {visibleFields.map(subq => (
              <Grid key={subq.id} item size={isMobile ? 12 : 6}>
                {renderField(subq)}
              </Grid>
            ))}
          </Grid>
        ) : (
          question.fixed_field ? (
            <Grid item size={isMobile ? 12 : 12}>
              {renderField(question.fixed_field)}
            </Grid>
          ) : null
        )}
      </Grid>
      <Grid item>
        <FormControlLabel
          control={
            <Checkbox
              checked={enabled}
              onChange={handleToggle}
            />
          }
          label="Use variable contributions"
        />
      </Grid>
    </Grid>
  );
};

export default ConditionalQuestionGroup;
